import DialpadIcon from 'crono-fe-common/icons/DialpadIcon';
import MicrophoneIcon from 'crono-fe-common/icons/Icon-Microphone';
import SettingsIcon from 'crono-fe-common/icons/Icon-Settings';
import MicrophoneOffIcon from 'crono-fe-common/icons/MicrophoneOffIcon';
import RecordIcon from 'crono-fe-common/icons/RecordIcon';
import { colors } from 'crono-fe-common/theme';
import { cn } from 'utils/style-utils';

export const CallControls = ({
  isOpen,
  isMuted,
  isRecording,
  isDialpadOpen,
  areSettingsOpen,
  mute,
  startRecording,
  openDialpad,
  openSettings,
}: {
  isOpen: boolean;
  isMuted: boolean;
  isRecording: boolean;
  isDialpadOpen: boolean;
  areSettingsOpen: boolean;
  mute: (shouldMute: boolean) => void;
  startRecording: () => void;
  openDialpad: (shouldOpen: boolean) => void;
  openSettings: (shouldOpen: boolean) => void;
}) => {
  return (
    <div className="grid grid-cols-4 gap-3 mt-6">
      <CallControl
        label="Mute"
        icon={
          isMuted ? (
            <MicrophoneOffIcon size={24} color={colors.white} />
          ) : (
            <MicrophoneIcon size={24} color={colors.black} />
          )
        }
        className={cn(isMuted && 'bg-gray-900 hover:bg-neutral-800')}
        disabled={!isOpen}
        onClick={() => mute(!isMuted)}
      />
      <CallControl
        label="Record"
        icon={
          <RecordIcon
            size={24}
            color={isRecording ? colors.inactive : colors.black}
          />
        }
        disabled={!isOpen || isRecording}
        onClick={startRecording}
      />
      <CallControl
        label="Dial Pad"
        icon={
          <DialpadIcon
            size={24}
            color={isDialpadOpen ? colors.white : colors.black}
          />
        }
        className={cn(isDialpadOpen && 'bg-gray-900 hover:bg-neutral-800')}
        disabled={!isOpen}
        onClick={() => openDialpad(!isDialpadOpen)}
      />
      <CallControl
        label="Settings"
        icon={<SettingsIcon size={24} color={colors.black} />}
        onClick={() => openSettings(!areSettingsOpen)}
      />
    </div>
  );
};

const CallControl = ({
  icon,
  label,
  className,
  disabled = false,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  className?: string;
  disabled?: boolean;
  onClick: () => void;
}) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <button
        className={cn(
          'size-12 rounded-full border border-neutral-400 bg-transparent grid place-content-center cursor-pointer hover:bg-neutral-100',
          'disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent',
          className,
        )}
        disabled={disabled}
        onClick={onClick}
      >
        {icon}
      </button>
      <span className="text-xs text-gray-700">{label}</span>
    </div>
  );
};
